<script>
import { GlAlert, GlLoadingIcon, GlSearchBoxByType, GlIcon } from '@gitlab/ui';
import axios from 'axios';
import { GlListIncident, GlStatus } from '~/components';

export default {
  name: 'IncidentListPage',
  components: {
    GlListIncident,
    GlLoadingIcon,
    GlAlert,
    GlSearchBoxByType,
    GlIcon,
    GlStatus,
  },
  data() {
    return {
      search: '',
      incidents: null,
      error: false,
      loading: true,
    };
  },
  computed: {
    noIncidents() {
      return !this.incidents?.length;
    },
    filteredIncidents() {
      return this.incidents.filter((incident) => {
        return incident.title.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    noSearchIncidents() {
      return !this.filteredIncidents?.length;
    },
  },
  mounted() {
    const URI = `/data/list.json`;
    this.fetchIncidents(URI);
  },
  methods: {
    fetchIncidents(URI) {
      return axios
        .get(URI)
        .then(({ data: { incidents } }) => {
          this.incidents = incidents;
          return incidents;
        })
        .catch(({ response: { status } }) => {
          if (status === 404) {
            this.incidents = [];
          } else {
            this.error = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<template>
  <div class="container gl-pt-5">
    <gl-loading-icon v-if="loading" />
    <gl-alert v-else-if="error" variant="warning" data-qa-selector="incident-list-error-alert">
      There was an error fetching the incidents. Please refresh the page to try again.
    </gl-alert>
    <gl-alert
      v-else-if="noIncidents"
      variant="success"
      data-qa-selector="incident-list-success-alert"
    >
      There are no active incidents to report. All systems are operational.
    </gl-alert>
    <div v-else-if="incidents">
      <gl-status :incidents="incidents" />
      <div class="gl-display-flex gl-justify-content-space-between gl-align-items-center">
        <h2 class="gl-mb-3">Incidents</h2>
        <gl-search-box-by-type v-model="search" data-qa-selector="incident-list-search" />
      </div>
      <div class="gl-display-grid incident-list gl-mt-5" data-qa-selector="incident-list">
        <gl-list-incident
          v-for="incident in filteredIncidents"
          :key="incident.id"
          :incident="incident"
          data-qa-selector="incident"
        />
      </div>
      <div
        v-if="noSearchIncidents"
        class="gl-display-flex gl-justify-content-center gl-align-items-center h4 gl-mt-5"
      >
        <gl-icon name="search" :size="24" class="gl-mr-2" />
        <div data-qa-selector="incident-list-empty-placeholder">
          We couldn't find any incidents matching
          <span
            class="gl-font-monospace gl-font-weight-bold gl-py-1 gl-px-2 gl-text-gray-950 gl-bg-gray-50 gl-rounded-base"
          >
            {{ search }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
